import React from 'react';
import { Link } from 'react-router-dom';

export default () => // <!-- Footer -->
(
    <div className="footer white_txt image_bck" data-color="#0e0e0e">
        <div className="container">

            <div className="row">
                <div className="col-md-5 col-sm-4">
                    <div className="logo text-left">
                        <Link to="/">
                            <b className="hidden-xs">Southern Africa Dream Tours & Safaris</b>
                            <b className="visible-xs">Dream Tours & Safaris</b>
                        </Link>
                    </div>
                    Connecting Your Dreams To Reality
                </div>

                <div className="col-md-4 col-sm-4 hidden-xs">
                    <div className="widget">
                        <h4>Contacts</h4>
                        <span className="contacts_ti ti-mobile" />
                        +1 434 962 6562
                        <br />
                        <span className="contacts_ti ti-email" />
                        <a href="mailto:bookings@southafricadreamtours.com">
                            bookings@southafricadreamtours.com
                        </a>
                    </div>
                    {/*<!--end of widget-->*/}
                </div>

            </div>
            {/*<!--Row End-->*/}

        </div>
        {/*< Container End */}

        {/*Footer Copyrights*/}
        <div className="footer_end">
            <div className="container">
                <div className="row">
                    <div className="col-sm-6">
                        <span className="sub">© Copyright 2017 - Southern Africa Dream Tours & Safaris</span>
                    </div>
                    <div className="col-sm-6 text-right">
                        <ul className="list-inline social-list">
                            
                            <li>
                                <a href="https://www.facebook.com/southernafricadreamtours" data-toggle="tooltip" data-placement="top" title="Facebook">
                                    <i className="ti-facebook"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company-beta/18141072" data-toggle="tooltip" data-placement="top" title="LinkedIn">
                                    <i className="ti-linkedin"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/sadts_2017" data-toggle="tooltip" data-placement="top" title="Instagram">
                                    <i className="ti-instagram"></i>
                                </a>
                            </li>
                            <li>
                                <a href="mailto:bookings@southafricadreamtours.com" data-toggle="tooltip" data-placement="top" title="Bookings">
                                    <i className="ti-email"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        {/* Copyrights End */}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx